import { Html4Entities } from 'html-entities'

export namespace HtmlUtils {
  // 스스플에서 'StringEscapeUtils.escapeHtml4()' 로 escape 하고 있어, 'Html4Entities' 사용해서 decode. 스스플의 escape 로직이 변경되면, 같이 바꿔줘야 함
  export const decodeHtmlContext = (str: string): string => {
    return Html4Entities.decode(str)
  }

  export const escapeOutput = (toOutput: string): string => {
    if (!toOutput) return toOutput

    return toOutput
      .replace(/\(/g, '&lt;')
      .replace(/\)/g, '&gt;')
      .replace(/\</g, '&lt;')
      .replace(/\>/g, '&gt;')
      .replace(/\"/g, '&quot;')
      .replace(/\'/g, '&#x27')
  }
}
